// extracted by mini-css-extract-plugin
var _1 = "CustomizeRecipientAudienceField-moduleformBody__a997J";
var _2 = "CustomizeRecipientAudienceField-moduleplaceholder__Rf5aa ButtonSelectControlContentPlaceholder-moduleButtonSelectControlContentPlaceholder__h946D";
var _3 = "CustomizeRecipientAudienceField-moduleselectButton__Z5jSz MultiSelect-moduleMultiSelect__EEZWk";
var _4 = "CustomizeRecipientAudienceField-moduletagBar__LEa_p TagBar-moduleTagBar__a7w7V";
export { _1 as "formBody", _2 as "placeholder", _3 as "selectButton", _4 as "tagBar" }
